export default "6f2248ca82575d2d.svg"